export const OTHER_CERTIFICATE_CODE = 'OTHER';
export const CERTIFICATE_CATALOG = [
    { code: 'WHMIS', label: 'WHMIS', group: 'HEALTH_AND_SAFETY' },
    {
        code: 'OHSA_AWARENESS',
        label: 'OHSA Worker Health & Safety Awareness',
        group: 'HEALTH_AND_SAFETY',
    },
    { code: 'FIRE_SAFETY', label: 'Fire Safety / Fire Prevention', group: 'HEALTH_AND_SAFETY' },
    { code: 'SAFE_LIFTS_TRANSFERS', label: 'Safe Lifts & Transfers', group: 'HEALTH_AND_SAFETY' },
    {
        code: 'WORKPLACE_VIOLENCE_HARASSMENT',
        label: 'Workplace Violence & Harassment Prevention',
        group: 'HEALTH_AND_SAFETY',
    },
    {
        code: 'EMERGENCY_PREPAREDNESS',
        label: 'Emergency Preparedness & Evacuation',
        group: 'HEALTH_AND_SAFETY',
    },
    { code: 'BACK_CARE_ERGONOMICS', label: 'Back Care & Ergonomics', group: 'HEALTH_AND_SAFETY' },
    { code: 'MECHANICAL_LIFT', label: 'Mechanical Lift Operation', group: 'HEALTH_AND_SAFETY' },
    // CPR is a REQUIRED credential for RN / RPN / PSW / DSW; it is offered here
    // only to care professionals none of whose roles require it (doc 16 lock 6).
    { code: 'CPR', label: 'CPR', group: 'CARE_TRAINING' },
    { code: 'GPA', label: 'GPA (Gentle Persuasive Approaches)', group: 'CARE_TRAINING' },
    { code: OTHER_CERTIFICATE_CODE, label: 'Other', group: 'OTHER' },
];
export const CERTIFICATE_GROUP_LABELS = {
    HEALTH_AND_SAFETY: 'Health & safety',
    CARE_TRAINING: 'Care training',
    OTHER: 'Other',
};
const CERTIFICATE_BY_CODE = new Map(CERTIFICATE_CATALOG.map((c) => [c.code, c]));
/** True iff `code` is a known certificate code (including OTHER). */
export function isCertificateCode(code) {
    return CERTIFICATE_BY_CODE.has(code);
}
/** Display name for a certificate: the catalog label, or the free-text name
 *  for OTHER. Falls back to the raw code. */
export function certificateDisplayName(code, customName) {
    if (code === OTHER_CERTIFICATE_CODE)
        return customName?.trim() || 'Other certificate';
    return CERTIFICATE_BY_CODE.get(code)?.label ?? code;
}
//# sourceMappingURL=certificate-catalog.js.map